;
define("product_details_image_gallery.tpl", function(){});

